import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from './Navbar';
import Footer from './Footer';
import BenefitsBar from './BenefitsBar';
import PromoBanner from './PromoBanner';
import WhatsAppButton from './WhatsAppButton';
import CartBubble from './CartBubble';
import WelcomePopup from './WelcomePopup';

const Layout = ({ children }) => {
  const location = useLocation();
  const [promoBannerHeight, setPromoBannerHeight] = useState(0);
  const lenisRef = useRef(null);

  // Páginas donde mostrar el marquee fijo
  const showMarqueeOn = ['/', '/products', '/cart'];
  const shouldShowMarquee = showMarqueeOn.includes(location.pathname) || location.pathname.startsWith('/products/');

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  // Lenis mantiene su propio estado de scroll y pisa el window.scrollTo(0,0)
  // de ScrollToTop al navegar entre páginas — hay que resetearlo también aquí.
  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col w-full max-w-[100vw] overflow-x-hidden">
      {/* Promo Banner - Fixed at very top */}
      <PromoBanner onHeightChange={setPromoBannerHeight} />
      
      {/* Spacer for promo banner */}
      {promoBannerHeight > 0 && <div style={{ height: promoBannerHeight }} />}
      
      {/* Benefits Bar - Fija encima del navbar */}
      {shouldShowMarquee && (
        <div 
          className="fixed left-0 right-0 z-50"
          style={{ top: `${promoBannerHeight}px` }}
        >
          <BenefitsBar />
        </div>
      )}
      
      {/* Navbar - fixed below benefits bar */}
      <Navbar promoOffset={promoBannerHeight} benefitsBarHeight={shouldShowMarquee ? 70 : 0} />
      
      {/* Single spacer for all fixed elements (BenefitsBar 70px + Navbar, o solo Navbar).
          El Navbar mide 64px en móvil (h-16) y 80px desde md (h-20) — medido en pantalla.
          Si el spacer fuera fijo en 150px, en móvil quedaría una franja de 16px entre el header y el hero. */}
      <div className={shouldShowMarquee ? 'h-[134px] md:h-[150px]' : 'h-16 md:h-20'} />

      <main className="flex-grow w-full max-w-[100vw] overflow-x-hidden">{children}</main>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <WhatsAppButton />

      {/* Floating Cart Bubble - arriba del botón de WhatsApp */}
      <CartBubble />

      {/* Welcome Popup for lead capture */}
      <WelcomePopup />
    </div>
  );
};

export default Layout;
